export default __webpack_public_path__ + "static/media/damageReport.86124c2b.png";